/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function GestionGeneral() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="purple"
                borderRadius="lg"
                coloredShadow="purple"
              >
                <MDTypography variant="h6" color="white">
                  Gestión General
                </MDTypography>
              </MDBox>
              <MDBox pt={3} pb={3} px={3}>
                <MDTypography variant="h5" gutterBottom>
                  Bienvenido a Gestión General
                </MDTypography>
                <MDTypography variant="body1" color="text">
                  Desde aquí puedes acceder a las diferentes secciones de gestión del sistema:
                </MDTypography>
                <MDBox mt={3}>
                  <MDTypography variant="h6" gutterBottom>
                    Módulos disponibles:
                  </MDTypography>
                  <MDBox component="ul" m={0} pl={4}>
                    <MDBox component="li" color="text" fontSize="0.875rem" lineHeight={1.625}>
                      <strong>Empresas Registradas:</strong> Consulta y gestiona todas las empresas registradas en el sistema
                    </MDBox>
                    <MDBox component="li" color="text" fontSize="0.875rem" lineHeight={1.625} mt={1}>
                      <strong>Reporte de Pruebas:</strong> Visualiza estadísticas de empresas y tests del sistema
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default GestionGeneral; 